import { stdObject } from "../data/types/stdObject";
import { applyDiscount } from "./applyDiscount";
import { toPrice } from "./toPrice";

export const recountTotals = ({
  tempData,
  index,
  key,
  type,
  value,
  params = {},
}: stdObject) => {
  const numericValue =
    key === "PRE" && params.blur ? Number(toPrice(value)) : value;

  const origin = { ...tempData.items[index], [key + type]: numericValue };

  const lineTotal = origin[`CAN${type}`] * origin[`PRE${type}`];
  origin[`TOT${type}`] = origin[`DES${type}`]
    ? applyDiscount(lineTotal, origin[`DES${type}`])
    : lineTotal;

  const items = [...tempData.items];
  items[index] = origin;

  return { ...tempData, items };
};
